export default __webpack_public_path__ + "static/media/cert.ac8987ed.svg";